var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"featurette"},[(_vm.icon)?_c('IconSvg',{attrs:{"name":_vm.icon}}):_vm._e(),(_vm.number)?_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.number))]):_vm._e(),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }